import * as actionType from "./Action_Type";
import { CALL_API } from "../Middlewares/api";
import { sortList } from "../Utils/Sorting";
import * as SGUri from "../Utils/PagesSwitch.js";
import { PRINT_GET_LIST, PRINT_FAVORITE_ADD_MODIFY, PRINT_DEFAULT_ADD_MODIFY } from "../Utils/Strings/Service_Endpoint";
import { refreshList, requestList } from "./Action_Utils.js";

export function getListaStampe(filter) {
  var obj = {
    ID        : filter.ID        ,
    Nome      : filter.Nome      ,
    IDAzienda : filter.IDAzienda      
  };
  
  return {
    [CALL_API]: {
      endpoint: PRINT_GET_LIST+SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_STAMPE_LIST_REQUEST,
        actionType.SERVICE_STAMPE_LIST_SUCCESS,
        actionType.SERVICE_STAMPE_LIST_ERROR
      ]
    } 
  };
}

export const changeFavoriteTemplate = (list, index) => ({
    type     : actionType.SERVICE_STAMPE_CHANGE_FAVORITE,
    list,
    index
});

export const changePredefiniteTemplate = (list, index) => ({
    type     : actionType.SERVICE_STAMPE_CHANGE_PREDEFINITE,
    list,
    index
});


export const setFavoriteTemplate = (template) => {
  var obj = {
    IDAzienda   : template.IDAzienda,
    IDStampa    : template.IDStampa,
    Predefinita : template.Predefinita,
    Preferita   : template.Preferita
  };

  return {
    [CALL_API]: {
      endpoint      : PRINT_FAVORITE_ADD_MODIFY,
      authenticated : true,
      method        : "POST",
      types         : [
        actionType.SERVICE_STAMPE_SET_FAVORITE_REQUEST,
        actionType.SERVICE_STAMPE_SET_FAVORITE_SUCCESS,
        actionType.SERVICE_STAMPE_SET_FAVORITE_ERROR
      ],
      data : SGUri.serializeParametersPOST(obj)
    }
  };
}

export const setPredefiniteTemplate = (template) => {
  var obj = {
    IDAzienda   : template.IDAzienda,
    IDStampa    : template.IDStampa,
    Predefinita : template.Predefinita,
    Preferita   : template.Preferita
  };
  return {
    [CALL_API]: {
      endpoint      : PRINT_DEFAULT_ADD_MODIFY,
      authenticated : true,
      method        : "POST",
      types         : [
        actionType.SERVICE_STAMPE_SET_PREDEFINITE_REQUEST,
        actionType.SERVICE_STAMPE_SET_PREDEFINITE_SUCCESS,
        actionType.SERVICE_STAMPE_SET_PREDEFINITE_ERROR
      ],
      data : SGUri.serializeParametersPOST(obj)
    }
  };
}


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Stampe.js